import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthProvider";
import { localStorageService } from "../../services/LocalStorageService";

const amountRequiredToShowHint = 30;

const isDiffPassed = (lastShown: DateTime | null) => {
	if (!lastShown) return true;
	const now = DateTime.now();
	return now.diff(lastShown).as("days") > amountRequiredToShowHint;
};

export const useSwipeHintLastTip = () => {
	const {
		userInfo: { id: userId },
	} = useAuth();
	const [lastShown, setLastShown] = useState(localStorageService.getSwipeJiggleHintLastShown(userId));

	useEffect(() => {
		if (!lastShown || isDiffPassed(lastShown)) {
			localStorageService.resetSwipeJiggleHintLastShown(userId);
			setLastShown(localStorageService.getSwipeJiggleHintLastShown(userId));
		}
	}, [lastShown]);

	return {
		lastShown: lastShown,
		isHintAvailable: isDiffPassed(lastShown),
	};
};
